import React from 'react';

export default () => <div id="search-results" className="left-panel" />;
